import type { ApiResponse, PaginatedResponse, QuestionnaireSession } from '@klaro7/shared-types';

import api from '@/lib/api';

export interface AdminSessionsParams {
  page?: number;
  limit?: number;
  status?: string;
}

export async function getAdminSessions(
  params?: AdminSessionsParams,
): Promise<PaginatedResponse<QuestionnaireSession>> {
  const response = await api.get<PaginatedResponse<QuestionnaireSession>>(
    '/questionnaire/admin/list',
    { params },
  );
  return response.data;
}

export async function getAdminSession(id: string): Promise<QuestionnaireSession> {
  const response = await api.get<ApiResponse<QuestionnaireSession>>(
    `/questionnaire/admin/${id}`,
  );
  return response.data.data;
}

export async function approveSession(id: string, approvalNotes: string): Promise<QuestionnaireSession> {
  const response = await api.put<ApiResponse<QuestionnaireSession>>(
    `/questionnaire/admin/${id}/approve`,
    { approvalNotes },
  );
  return response.data.data;
}

export async function saveFieldRatings(
  id: string,
  ratings: Record<string, { rating: number; comment?: string }>,
): Promise<QuestionnaireSession> {
  const response = await api.put<ApiResponse<QuestionnaireSession>>(
    `/questionnaire/admin/${id}/field-ratings`,
    { ratings },
  );
  return response.data.data;
}

export async function rejectSession(
  id: string,
  reason: string,
): Promise<QuestionnaireSession> {
  const response = await api.put<ApiResponse<QuestionnaireSession>>(
    `/questionnaire/admin/${id}/reject`,
    { reason },
  );
  return response.data.data;
}
